module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("32tVp"))).then(() => parcelRequire('8rm4T'));